import { jsx as _jsx } from "react/jsx-runtime";
import { Container as MuiContainer, } from '@mui/material';
import { styled } from '../../utils';
export function Container({ spacing, maxWidth, ...props }) {
    return (_jsx(ContainerStyled, { spacing: spacing, maxWidth: maxWidth || false, ...props }));
}
const ContainerStyled = styled(MuiContainer, {
    shouldForwardProp: (prop) => prop !== 'spacing',
})(({ theme, spacing }) => ({
    padding: typeof spacing === 'number' ? theme.spacing(spacing) : 0,
    [theme.breakpoints.down('md')]: {
        padding: typeof spacing === 'number'
            ? theme.spacing(spacing / 2.5) // TODO: should test what is the best match for mobile
            : theme.spacing(2),
    },
}));
